/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, Fragment, useState } from "react";
import {
  MdAssignmentTurnedIn,
  MdOutlineFilterAlt,
  MdOutlineMessage,
  MdOutlineSearch,
} from "react-icons/md";
import { ToastContainer } from "react-toastify";
import {
  CATEGORY_CONFIG_URL,
  CONSTITUENCY_CONFIG_URL,
  DEFAULTER_LOAN_REMINDER,
  DISTRICT_CONFIG_URL,
  GET_INTEREST_ON_INTEREST_DETAILS,
  GET_PENAL_INTEREST_DETAILS,
  GRAMPANCHAYAT_CONFIG_URL,
  MUNICIPAL_CORPORATION_CONFIG_URL,
  NAGAR_PANCHAYAT_CONFIG_URL,
  NOTICE_URL,
  REPORTS_CONFIG_URL,
  SCHEME_CONFIG_URL,
  SUBDIVISION_CONFIG_URL,
} from "../../../../api/api_routing_urls";
import useAuth from "../../../../authentication/hooks/useAuth";
import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import Dashboard from "../../../../common/Dashboard";
import Button from "../../../../reusable-components/buttons/Button";
import H2withIcon from "../../../../reusable-components/headings/H2withIcon";
import LoadingModal from "../../../../reusable-components/modals/LoadingModal";
import FilterDropdown from "../../../../reusable-components/search/FilterDropdown";
import {
  defaulterDD,
  genderDD,
} from "../../../../utilities/constants/constants";

import showToast from "../../../../utilities/notification/NotificationModal";
import DefaulterDetailList from "./DefaulterDetailList";
import ReactToPrint from "react-to-print";

import { PrintReport } from "../PrintReport/PrintReport";
import DefaulterDetailListPrint from "./DefaulterDetailListPrint";
import ConfirmationModal from "../../../../reusable-components/modals/ConfirmationModal";
import {
  IoCloseCircleOutline,
  IoInformationCircleOutline,
  IoPaperPlaneOutline,
} from "react-icons/io5";
import { formatINRCurrency } from "../../../../utilities/currency/currency";
import { getFormattedDateDDMMMYYYYDate } from "../../../../utilities/dateFunctions/formatdate";
import { number_in_words } from "../../../../utilities/generalFunctions/numberToWrod";
import { PrintBulkDemandNotice } from "../PrintReport/PrintBulkDemandNotice";

//#region Notes
/* 
Notes for future developers:

1. For the bulk demand notice -> all ids will be listed here (sendLoanReminderList)
*/

//#endregion

const DefaulterDetailConfig = () => {
  const { auth } = useAuth();
  const [defaulterDetailList, setDefaulterDetailList] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const [showSendSMS, setShowSendSMS] = useState(false);
  const printRef = useRef();

  const [editRepaymentDetails, setEditRepaymentDetails] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [pageNo, setPageNo] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(1);
  const pageSize = 10;

  const [categoryList, setCategoryList] = useState([]);
  const [schemeList, setSchemeList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [constituencyList, setConstituencyList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [gramPanchayatList, setGramPanchayatList] = useState([]);
  const [nagarPanchayatList, setNagarPanchayatList] = useState([]);
  const [municipalCorporationList, setMunicipalCorporationList] = useState([]);

  const [selectedDefaulterType, setSelectedDefaulterType] = useState();

  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedApplicantGender, setSelectedApplicantGender] = useState();
  const [selectedSchemeName, setSelectedSchemeName] = useState();
  const [selectedDistrictName, setSelectedDistrictName] = useState();
  const [selectedConstituencyName, setSelectedConstituencyName] = useState();
  const [selectedSubDivisionName, setSelectedSubDivisionName] = useState();
  const [selectedGramPanchayatName, setSelectedGramPanchayatName] = useState();
  const [selectedMumicipalCorporationName] = useState();
  const [selectedNagarPanchayatName, setSelectedNagarPanchayatName] =
    useState();

  const [sendLoanReminderList, setSendLoanReminderList] = useState([]);

  const [showFilters, setShowFilters] = useState(false);

  const controller = new AbortController();

  const [showNoticeModal, setShowNoticeModal] = useState(false);
  const [showBulkDemandNotices, setShowBulkDemandNotices] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [loadingGenerate, setLoadingGenerate] = useState(false);
  const [showPrintButton, setShowPrintButton] = useState(false);
  // get searched repayment list
  const getDefaulterDetailList = async () => {
    try {
      setIsLoading(true);
      const response = await axiosPrivate.get(
        `${REPORTS_CONFIG_URL}/getDefaulterDetailListConfig`,
        {
          params: {
            defaulterlisttype:
              selectedDefaulterType?.label || "Exceeding 2 Years",
            applicantgender: selectedApplicantGender?.value || "",
            categoryname: selectedCategory?.label || "",
            schemename: selectedSchemeName?.label || "",
            districtname: selectedDistrictName?.label || "",
            constituencyname: selectedConstituencyName?.label || "",
            subdivisionname: selectedSubDivisionName?.label || "",
            grampanchayatname: selectedGramPanchayatName?.label || "",
            municipalcorporationname:
              selectedMumicipalCorporationName?.label || "",
            nagarpanchayatname: selectedNagarPanchayatName?.label || "",
            pgno: pageNo || 1,
            pgsize: pageSize || 10,
          },
        },
        {
          signal: controller.signal,
        },
      );

      if (response?.status === 200) {
        setDefaulterDetailList(response?.data?.defaulterDetailList || []);
        console.log(
          "defaulterDetailList",
          response?.data?.defaulterDetailList || [],
        );

        const totalNumberOfApplicant = 0;

        // getting total Number Of pages
        setNumberOfPages(Math.ceil(totalNumberOfApplicant / pageSize));
      }
      response.status === 202 &&
        showToast("No state list found in the system", "error");
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error",
        );
      }
    }
  };

  // get category list
  const getCategoryList = async () => {
    try {
      const response = await axiosPrivate.get(CATEGORY_CONFIG_URL, {
        signal: controller.signal,
      });

      if (response?.status === 200) {
        if (response?.data?.categoryList?.length > 0) {
          let categoryDD = [];

          response?.data?.categoryList?.map((categoryOBJ) => {
            let categoryObj = {
              value: categoryOBJ?.categoryid,
              label: categoryOBJ?.categoryname,
            };

            categoryDD.push(categoryObj);
          });
          setCategoryList(categoryDD);
        } else {
          setCategoryList([]);
        }
      }
      response.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      console.error(error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error",
        );
      }
    }
  };
  // get scheme list
  const getSchemeList = async () => {
    try {
      const response = await axiosPrivate.get(SCHEME_CONFIG_URL, {
        signal: controller.signal,
      });

      if (response?.status === 200) {
        if (response?.data?.schemeList?.length > 0) {
          let SchemeDD = [];
          response?.data?.schemeList?.map((schemeObj) => {
            let SchemeObj = {
              value: schemeObj.schemeid,
              label: `${schemeObj.schemename}
              ${" "}(${schemeObj.schemeshortname})`,
            };
            SchemeDD.push(SchemeObj);
          });
          setSchemeList(SchemeDD);
        } else {
          setSchemeList([]);
        }
      }
      response.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      console.error(error);
    }
  };
  // get District List
  const getDistrictList = async () => {
    try {
      const response = await axiosPrivate.get(DISTRICT_CONFIG_URL, {
        signal: controller.signal,
      });

      if (response?.status === 200) {
        if (response?.data?.districtList?.length > 0) {
          let districtDD = [];
          response?.data?.districtList?.map((districtObj) => {
            let districtObjDD = {
              value: districtObj.districtid,
              label: districtObj.districtname,
            };
            districtDD.push(districtObjDD);
          });
          setDistrictList(districtDD);
        } else {
          setDistrictList([]);
        }
      }
      response.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      console.error(error);
    }
  };
  // get constituency list
  const getConstituencyList = async () => {
    try {
      const response = await axiosPrivate.get(CONSTITUENCY_CONFIG_URL, {
        signal: controller.signal,
      });

      if (response?.status === 200) {
        if (response?.data?.constituencyList?.length > 0) {
          let constituencyDD = [];
          response?.data?.constituencyList?.map((constituencyObj) => {
            let constituencyObjDD = {
              value: constituencyObj.constituencyid,
              label: constituencyObj.constituencyname,
            };
            constituencyDD.push(constituencyObjDD);
          });
          setConstituencyList(constituencyDD);
        } else {
          setConstituencyList([]);
        }
      }
      response.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      console.error(error);
    }
  };
  // get sub division
  const getSubDivisionList = async () => {
    try {
      const response = await axiosPrivate.get(SUBDIVISION_CONFIG_URL, {
        signal: controller.signal,
      });

      if (response?.status === 200) {
        if (response?.data?.subDivisionList?.length > 0) {
          let subDivisionDD = [];
          response?.data?.subDivisionList?.map((subDivisionObj) => {
            let subDivisionObjDD = {
              value: subDivisionObj?.subdivisionid,
              label: subDivisionObj?.subdivisionname,
            };
            subDivisionDD.push(subDivisionObjDD);
          });
          setSubDivisionList(subDivisionDD);
        } else {
          setSubDivisionList([]);
        }
      }
      response.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      console.error(error);
    }
  };
  // get gram panchayat list
  const getGramPanchayatList = async () => {
    try {
      const response = await axiosPrivate.get(GRAMPANCHAYAT_CONFIG_URL, {
        signal: controller.signal,
      });

      if (response?.status === 200) {
        if (response?.data?.grampanchayatList?.length > 0) {
          let gramPanchayatDD = [];
          response?.data?.grampanchayatList?.map((gramPanchayatObj) => {
            let gramPanchayatObjDD = {
              value: gramPanchayatObj.grampanchayatid,
              label: gramPanchayatObj.grampanchayatname,
            };
            gramPanchayatDD.push(gramPanchayatObjDD);
          });
          setGramPanchayatList(gramPanchayatDD);
        } else {
          setGramPanchayatList([]);
        }
      }
      response.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      console.error(error);
    }
  };
  // get nagar panchayat
  const getNagarPanchayatList = async () => {
    try {
      const response = await axiosPrivate.get(NAGAR_PANCHAYAT_CONFIG_URL, {
        signal: controller.signal,
      });

      if (response?.status === 200) {
        if (response?.data?.nagarPanchayatList?.length > 0) {
          let nagarPanchayatDD = [];
          response?.data?.nagarPanchayatList?.map((nagarpanchayatObj) => {
            let nagarPanchayatObjDD = {
              value: nagarpanchayatObj.nagarpanchayatid,
              label: nagarpanchayatObj.nagarpanchayatname,
            };
            nagarPanchayatDD.push(nagarPanchayatObjDD);
          });
          setNagarPanchayatList(nagarPanchayatDD);
        } else {
          setNagarPanchayatList([]);
        }
      }
      response.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      console.error(error);
    }
  };
  // get municipal corporation
  const getMunicipalCorporationList = async () => {
    try {
      const response = await axiosPrivate.get(
        MUNICIPAL_CORPORATION_CONFIG_URL,
        {
          signal: controller.signal,
        },
      );

      if (response?.status === 200) {
        if (response?.data?.municipalCorporationList?.length > 0) {
          let municipalCorporationDD = [];
          response?.data?.municipalCorporationList?.map(
            (municipalCorporationObj) => {
              let municipalCorporationObjDD = {
                value: municipalCorporationObj?.municipalcorporationid,
                label: municipalCorporationObj?.municipalcorporationname,
              };
              municipalCorporationDD.push(municipalCorporationObjDD);
            },
          );

          setMunicipalCorporationList(municipalCorporationDD);
        } else {
          setMunicipalCorporationList([]);
        }
      }
      response.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      console.error(error.message);
    }
  };

  // function for page change
  const onPageChangeHandler = (page_no, action_type) => {
    if (action_type === "Next") {
      parseInt(page_no) + 1 <= numberOfPages &&
        setPageNo(() => parseInt(page_no) + 1);
    }
    if (action_type === "Prev") {
      parseInt(page_no) - 1 >= 1 && setPageNo(() => parseInt(page_no) - 1);
    }
  };

  const getSearchedResult = () => {
    getDefaulterDetailList();
  };

  // POST SEND DEFAULTER LOAN REMINDER SMS
  const sendLoanReminder = async () => {
    try {
      const response = await axiosPrivate.post(
        DEFAULTER_LOAN_REMINDER,
        { loan_reminder_list: JSON.stringify(sendLoanReminderList) },
        {
          signal: controller.signal,
        },
      );

      if (response?.status === 200) {
        console.log(response.data);
        showToast("SMS reminders to defaulters send successfully", "success");
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setShowSendSMS(false);
    }
  };

  const getPenalInterestDetail = async (loan_number) => {
    try {
      let response = await axiosPrivate?.get(
        GET_PENAL_INTEREST_DETAILS,
        {
          params: {
            loan_number: loan_number || "",
            // loan_number: "NVT0000101",
          },
        },
        {
          signal: controller.signal,
        },
      );

      console.log("response for penal interest", response);

      if (response.data) {
        console.log(+response?.data?.ledgerDetails?.penal_due_amount || 0);
        return +response?.data?.ledgerDetails?.penal_due_amount || 0;
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }

    return 0;
  };

  const getInterestOnInterestDetail = async (loan_number) => {
    try {
      let response = await axiosPrivate.get(
        GET_INTEREST_ON_INTEREST_DETAILS,
        {
          params: {
            loan_number: loan_number || "",
            // loan_number: "NVT0000101",
          },
        },
        {
          signal: controller.signal,
        },
      );

      if (response.data) {
        console.log(response?.data?.ledgerDetails?.ioi_due_amount || 0);
        return +response?.data?.ledgerDetails?.ioi_due_amount;
      }
    } catch (error) {
      console.error(error);
    }

    return 0;
  };

  const handleGenerateBulkDemandNotice = async () => {
    setLoadingGenerate(true);

    try {
      const loaneeArray = sendLoanReminderList.map((item) => ({
        loan_ee_id: item.loanee_id,
        category_type: item.full_info.categoryname,
      }));

      const response = await axiosPrivate.post(
        `${NOTICE_URL}/save-notice-details-in-bulk`,
        {
          loanee_data: JSON.stringify(loaneeArray),
          generated_date: selectedDate,
          createdby: auth.userid,
          notice_type: "Demand Notice",
        },
        {
          signal: controller.signal,
        },
      );

      const resp = response.data.data;

      // console.log(resp);

      if (resp.status === true) {
        const updated = sendLoanReminderList.map((item) => {
          const found = resp.data.find((r) => r.loanee_id == item.loanee_id);

          return {
            ...item,
            reference_number: found?.ref_num || "NA",
          };
        });

        // console.log(updated);

        setSendLoanReminderList(updated);
      }

      if (response.status === 200 && resp.status === true) {
        showToast("Bulk reference numbers generated successfully", "success");

        // getDemandNoticeList();
        // reset();
        setShowPrintButton(true);
        return;
      }

      if (resp.status === false && resp.reason) {
        showToast(resp.message || "Already exist", "warning");
        return;
      }

      showToast(
        "Something went wrong while generating notices. Please contact administrator.",
        "error",
      );
    } catch (error) {
      console.error(error);

      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops! Something went wrong. Please contact administrator.",
          "error",
        );
      }
    } finally {
      // getDemandNoticeList();
      setLoadingGenerate(false);
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getDefaulterDetailList();
    }

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [
    selectedDefaulterType?.value,
    selectedCategory?.value,
    selectedDistrictName?.value,
    selectedConstituencyName?.value,
    selectedApplicantGender?.value || "",
  ]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getCategoryList();
      getSchemeList();
      getConstituencyList();
      getGramPanchayatList();
      getDistrictList();
      getMunicipalCorporationList();
      getSubDivisionList();
      getNagarPanchayatList();
    }

    setEditRepaymentDetails({});
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  useEffect(() => {
    const loadData = async () => {
      const updated = await Promise?.all(
        sendLoanReminderList?.map(async (item) => {
          const penal = await getPenalInterestDetail(
            item?.full_info?.loan_number || "",
          );
          const ioi = await getInterestOnInterestDetail(
            item?.full_info?.loan_number || "",
          );

          return {
            ...item,
            penal_interest: penal,
            interest_on_interest: ioi,
          };
        }),
      );

      setSendLoanReminderList(updated);
    };

    if (sendLoanReminderList.length > 0) loadData();
  }, [sendLoanReminderList.length]);

  console.log({ sendLoanReminderList });

  return (
    <Dashboard sidebarType={auth?.rolename}>
      <ToastContainer />
      {isLoading ? (
        <Fragment>
          <LoadingModal message={"Loading"} />
        </Fragment>
      ) : (
        <>
          <div className="flex items-center justify-between gap-2">
            <H2withIcon>
              <MdAssignmentTurnedIn />{" "}
              <span className="pl-1.5">Defaulter Details</span>
            </H2withIcon>
          </div>
        </>
      )}

      <>
        <section className="flex flex-wrap gap-3 justify-between items-end">
          <div>
            <FilterDropdown
              defaultName="filterDefaulterListType"
              required={true}
              classes={`text-sm w-full`}
              placeholder={"Select Defaulter Type"}
              data={defaulterDD}
              defaultValue={null}
              setSelected={setSelectedDefaulterType}
              selected={selectedDefaulterType}
              maxMenuHeight={256}
            />
          </div>

          <div className="flex items-center justify-center gap-x-6">
            {/* Important: undo the comment before deoplyment */}
            {sendLoanReminderList?.length > 0 ? (
              <>
                <Button
                  className={
                    "bg-primary text-white text-sm px-3 py-2 md:min-w-36 flex items-center justify-center gap-1"
                  }
                  onClick={() => {
                    setShowSendSMS(true);
                  }}
                >
                  Send Loan Reminder
                  <MdOutlineMessage size={18} />
                </Button>
              </>
            ) : null}

            {/* {sendLoanReminderList?.length > 0 ? (
              <>
                <Button
                  className={
                    "bg-primary text-white text-sm px-3 py-2 md:min-w-36 flex items-center justify-center gap-1"
                  }
                  onClick={() => {
                    setShowNoticeModal(true);
                  }}
                >
                  Bulk Demand Notice
                  <IoPaperPlaneOutline size={18} />
                </Button>
              </>
            ) : null} */}
          </div>

          <ConfirmationModal
            open={showSendSMS}
            setOpen={setShowSendSMS}
            message={`Are you ready to send SMS reminders to ${sendLoanReminderList?.length} defaulters?`}
            btnName={"Confirm"}
            onConfirm={() => sendLoanReminder()}
          />

          <div className="flex gap-2">
            <Button
              className={
                "border border-primary text-primary text-sm px-2 py-1 md:min-w-36 flex items-center justify-center gap-1"
              }
              onClick={() => {
                setShowFilters(!showFilters);
              }}
            >
              Apply Filters
              <MdOutlineFilterAlt size={18} />
            </Button>
            <Button
              className={
                "bg-primary text-white text-sm px-3 py-2 md:min-w-36 flex items-center justify-center gap-1"
              }
              onClick={() => getSearchedResult()}
            >
              Search
              <MdOutlineSearch size={18} />
            </Button>
          </div>
        </section>
        {showFilters && (
          <section className="grid grid-cols-1 md:grid-cols-4 gap-2 mt-3">
            <FilterDropdown
              defaultName="filterCategory"
              required={true}
              classes={`text-sm w-full`}
              placeholder={"Select Category..."}
              data={categoryList}
              defaultValue={null}
              setSelected={setSelectedCategory}
              selected={selectedCategory}
              maxMenuHeight={256}
            />
            <FilterDropdown
              defaultName="filterGender"
              required={true}
              classes={`text-sm w-full`}
              placeholder={"Select Gender..."}
              data={genderDD}
              defaultValue={null}
              setSelected={setSelectedApplicantGender}
              selected={selectedApplicantGender}
              maxMenuHeight={256}
            />

            <FilterDropdown
              defaultName="filterDistrict"
              required={true}
              classes={`text-sm w-full`}
              placeholder={"Select District..."}
              data={districtList}
              defaultValue={null}
              setSelected={setSelectedDistrictName}
              selected={selectedDistrictName}
              maxMenuHeight={256}
            />
            <FilterDropdown
              defaultName="filterConstituency"
              required={true}
              classes={`text-sm w-full`}
              placeholder={"Select Constituency..."}
              data={constituencyList}
              defaultValue={null}
              setSelected={setSelectedConstituencyName}
              selected={selectedConstituencyName}
              maxMenuHeight={256}
            />
          </section>
        )}
      </>

      <div className="grid grid-cols-1 mt-6">
        <div className="mb-2 text-slate-800 text-sm">
          {" "}
          Defaulters:
          <span className="font-semibold text-base ml-1">
            {" "}
            {defaulterDetailList?.length || 0}
          </span>
        </div>

        <DefaulterDetailList
          defaulterDetailList={defaulterDetailList}
          sendLoanReminderList={sendLoanReminderList}
          setSendLoanReminderList={setSendLoanReminderList}
        />
        {defaulterDetailList?.length > 0 ? (
          <PrintReport reportTitle={"Defaulter Report"}>
            <DefaulterDetailListPrint
              defaulterDetailList={defaulterDetailList}
              selectedDefaulterType={selectedDefaulterType}
              selectedCategory={selectedCategory}
              selectedDistrictName={selectedDistrictName}
              selectedConstituencyName={selectedConstituencyName}
            />
          </PrintReport>
        ) : null}
      </div>
      {defaulterDetailList[0]?.listcount > 0 && (
        <>
          <section className="mt-4 p-2 bg-slate-200 text-sm">
            <p>
              Total principle due amount:{" "}
              <span className="font-semibold">
                ₹{defaulterDetailList[0]?.principledue}
              </span>
            </p>
            <p>
              Total interest due amount:{" "}
              <span className="font-semibold">
                ₹{defaulterDetailList[0]?.interestdue}
              </span>
            </p>
            <p>
              Total amount sanctioned:{" "}
              <span className="font-semibold">
                ₹{defaulterDetailList[0]?.totalsanctionamount}
              </span>
            </p>
            <p>
              Total number of borrower:{" "}
              <span className="font-semibold">
                {defaulterDetailList[0]?.listcount}
              </span>
            </p>
          </section>
        </>
      )}
      {numberOfPages > 1 && (
        <>
          <div className="flex justify-between mt-6">
            <Button
              className={`${
                pageNo === 1
                  ? "cursor-not-allowed bg-slate-600"
                  : "cursor-pointer"
              } bg-secondary text-sm px-3 py-2 text-white md:min-w-36 flex items-center justify-center gap-1`}
              onClick={() => {
                onPageChangeHandler(pageNo, "Prev");
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
              Previous
            </Button>
            {pageNo} / {numberOfPages || 1}
            <Button
              className={`${
                pageNo === numberOfPages
                  ? "cursor-not-allowed bg-slate-600"
                  : "cursor-pointer"
              }             
                    bg-secondary text-sm px-3 py-2 text-white md:min-w-36 flex items-center justify-center gap-1`}
              onClick={() => {
                onPageChangeHandler(pageNo, "Next");
              }}
            >
              Next
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </Button>
          </div>
        </>
      )}

      {/* Bulk Demand Notice module */}
      {showNoticeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          {!showBulkDemandNotices && (
            <div className="bg-white  rounded-lg shadow-lg w-full max-w-4xl p-6">
              {/* Modal Header */}
              <div className="flex justify-between items-center border-b pb-1">
                <h2 className="text-lg font-semibold">Demand Notice List</h2>
                <div className="flex items-center justify-center gap-x-10">
                  <div>
                    <input
                      type="date"
                      className="border px-2 py-1 rounded"
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                      max={new Date().toISOString().split("T")[0]}
                    />
                  </div>

                  <button
                    onClick={() => {
                      setShowNoticeModal(false);
                      setSelectedDate("");
                    }}
                    className="text-gray-600 hover:text-red-600"
                  >
                    <IoCloseCircleOutline size={22} />
                  </button>
                </div>
              </div>

              {/* Table */}
              <div className="overflow-x-auto mt-4 max-h-[30rem] min-h-[30rem]">
                <table className="table-auto w-full text-left border border-gray-300">
                  <thead className="bg-gray-200">
                    <tr>
                      <th className="p-2 border text-center">Sl No.</th>
                      <th className="p-2 border text-center">Loanee Id</th>
                      <th className="p-2 border text-center">Full Name</th>
                      <th className="p-2 border text-center">District</th>
                      <th className="p-2 border text-center">Category</th>
                      <th className="p-2 border text-center">Due Amount</th>
                      <th className="p-2 border text-center">Phone</th>
                    </tr>
                  </thead>

                  <tbody>
                    {sendLoanReminderList?.map((item, index) => (
                      <tr key={index} className="hover:bg-gray-100">
                        <td className="p-2 border text-center">{index + 1}</td>
                        <td className="p-2 border text-center">
                          {item.loanee_id}
                        </td>
                        <td className="p-2 border text-center">
                          {item.applicantname}
                        </td>
                        <td className="p-2 border text-center">
                          {item?.full_info?.districtname}
                        </td>
                        <td className="p-2 border text-center">
                          {item?.full_info?.categoryname}
                        </td>
                        <td className="p-2 border text-center">
                          {formatINRCurrency(
                            (+item?.full_info?.interest_due_amount || 0) +
                              (+item?.full_info?.principle_due || 0) +
                              (+item?.penal_interest || 0) +
                              (+item?.interest_on_interest || 0),
                          )}
                        </td>
                        <td className="p-2 border text-center">
                          {item.phonenumber}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Modal Footer */}
              <div className="flex justify-end mt-4 gap-3">
                <button
                  className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                  onClick={() => {
                    setShowNoticeModal(false);
                    setSelectedDate("");
                  }}
                >
                  Close
                </button>
                {selectedDate ? (
                  <button
                    title={!selectedDate && "Please select a date first"}
                    disabled={selectedDate ? "" : "disable"}
                    onClick={() => {
                      setShowBulkDemandNotices(true);
                    }}
                    className={`px-4 py-2 ${
                      selectedDate
                        ? "bg-primary text-white rounded hover:bg-primary"
                        : "bg-slate-600 text-slate-400 cursor-not-allowed"
                    }   `}
                  >
                    Confirm & Proceed
                  </button>
                ) : (
                  <span className="border flex items-center gap-x-1 justify-center text-red-500 bg-slate-100 px-3 rounded-md pt-1">
                    <IoInformationCircleOutline size={21} />{" "}
                    <span>Please select a date to continue</span>
                  </span>
                )}
              </div>
            </div>
          )}

          {/* all the pdf listed */}

          {showBulkDemandNotices && (
            <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl p-6">
              {/* Modal Header */}
              <div className="flex justify-between items-center border-b pb-1">
                <h2 className="text-lg font-semibold">Demand Notice List</h2>
                <button
                  onClick={() => {
                    setShowBulkDemandNotices(false);
                    setSelectedDate("");
                  }}
                  className="text-gray-600 hover:text-red-600"
                >
                  <IoCloseCircleOutline size={22} />
                </button>
              </div>

              <div className="min-h-[30rem] max-h-[30rem] overflow-auto overflow-x-hidden  rounded bg-white ">
                {sendLoanReminderList?.map((loaneeDetails, index) => (
                  <div className="mb-12" key={index}>
                    <div className="relative top-6 left-1">
                      <span className="bg-green-100 text-green-600 rounded-full h-5 w-5 flex items-center justify-center text-xs font-semibold">
                        {index + 1}
                      </span>
                    </div>
                    <section
                      key={index}
                      className="text-[14px] px-4 md:px-6 py-4 w-full max-w-[900px] mx-auto bg-[#f0fdf488] shadow-sm border border-[#ceead7ba] rounded mb-6"
                    >
                      {/* Letter Header */}
                      <div className="flex flex-wrap justify-between mb-4 gap-y-2">
                        <p className="font-semibold flex ">
                          Ref.No:{" "}
                          {loadingGenerate ? (
                            <span className="flex items-center justify-center gap-x-1 ps-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="size-5 animate-spin"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                                />
                              </svg>
                              <span className="text-slate-800 font-medium">
                                Generating...
                              </span>
                            </span>
                          ) : (
                            <span>
                              {loaneeDetails?.reference_number || "NA"}
                            </span>
                          )}
                        </p>
                        <p className="font-semibold">
                          Date: {getFormattedDateDDMMMYYYYDate(selectedDate)}
                        </p>
                      </div>

                      {/* Recipient Details */}
                      <div className="my-6 leading-tight">
                        <p>To,</p>
                        <p className="font-semibold break-words">
                          {loaneeDetails?.full_info?.applicantname}
                        </p>
                        <p className="font-semibold uppercase break-words">
                          {loaneeDetails?.full_info?.applicantrelative}:{" "}
                          {loaneeDetails?.full_info?.applicantrelativename}
                        </p>
                        <p className="font-semibold uppercase break-words">
                          {loaneeDetails?.full_info?.permanentaddress}
                        </p>
                      </div>

                      {/* Subject */}
                      <p className="underline font-semibold">
                        Subject: Demand Notice for repayment of loan.
                      </p>

                      {/* Body Content */}
                      <div className="mt-6 leading-relaxed">
                        <p>Dear Sir/Madam,</p>
                        <p className="mt-4">
                          This is to inform you that a sum of
                          <span className="font-semibold">
                            {formatINRCurrency(
                              (+loaneeDetails?.full_info?.interest_due_amount ||
                                0) +
                                (+loaneeDetails?.full_info?.principle_due ||
                                  0) +
                                (+loaneeDetails?.penal_interest || 0) +
                                (+loaneeDetails?.interest_on_interest || 0),
                            )}
                          </span>{" "}
                          has fallen due for repayment against your{" "}
                          <span className="font-semibold">
                            {loaneeDetails?.full_info?.schemename}
                          </span>{" "}
                          loan ID.No:{" "}
                          <span className="font-semibold">
                            {loaneeDetails?.full_info?.loanee_id}
                          </span>{" "}
                          account with this Corporation. The detail of the
                          amount payable as on{" "}
                          <span className="font-semibold">
                            {getFormattedDateDDMMMYYYYDate(selectedDate)}
                          </span>{" "}
                          by you is given in the schedule below :
                        </p>
                      </div>

                      {/* Schedule I */}
                      <div className="grid grid-cols-2 gap-6 pt-6">
                        <div>
                          <h2 className="underline underline-offset-2 font-semibold">
                            Schedule I
                          </h2>
                          <ul className="list-decimal pl-6 pt-2 space-y-1">
                            <li>Principle Default</li>
                            <li>Interest due</li>
                            {loaneeDetails?.full_info?.categoryname ===
                              "OBC" && (
                              <>
                                <li>Penal Interest</li>
                                <li>Interest on Interest</li>
                              </>
                            )}
                          </ul>
                        </div>

                        <div>
                          <h2 className="underline underline-offset-2 font-semibold">
                            Amount
                          </h2>
                          <ul className="pt-2 space-y-1">
                            <li className="font-semibold">
                              {formatINRCurrency(
                                loaneeDetails?.full_info?.principle_due,
                              )}
                            </li>
                            <li className="font-semibold">
                              {formatINRCurrency(
                                loaneeDetails?.full_info?.interest_due_amount,
                              )}
                            </li>

                            {loaneeDetails?.full_info?.categoryname ===
                              "OBC" && (
                              <>
                                <li className="font-semibold">
                                  {formatINRCurrency(
                                    +loaneeDetails?.penal_interest,
                                  )}
                                </li>
                                <li className="font-semibold">
                                  {formatINRCurrency(
                                    +loaneeDetails?.interest_on_interest,
                                  )}
                                </li>
                              </>
                            )}
                          </ul>

                          <p className="font-semibold pt-2">
                            Total :
                            {formatINRCurrency(
                              loaneeDetails?.full_info?.principle_outstanding +
                                loaneeDetails?.full_info?.interest_due_amount ||
                                0,
                            )}
                          </p>
                        </div>
                      </div>

                      <p className="pt-3 ml-6 font-semibold">
                        (Rupees{" "}
                        <span className="font-bold">
                          {number_in_words(
                            loaneeDetails?.full_info?.principle_outstanding +
                              loaneeDetails?.full_info?.interest_due_amount,
                          ) || 0}
                        </span>{" "}
                        only)
                      </p>

                      {/* Schedule II */}
                      <div className="grid grid-cols-2 gap-6 pt-6">
                        <div>
                          <h2 className="underline underline-offset-2 font-semibold">
                            Schedule II
                          </h2>
                          <ul className="list-decimal pl-6 pt-2 space-y-1">
                            <li>Principle Outstanding</li>
                            <li>Interest due</li>
                            {loaneeDetails?.full_info?.categoryname ===
                              "OBC" && (
                              <>
                                <li>Penal Interest</li>
                                <li>Interest on Interest</li>
                              </>
                            )}
                          </ul>
                        </div>

                        <div>
                          <h2 className="underline underline-offset-2 font-semibold">
                            Amount
                          </h2>
                          <ul className="pt-2 space-y-1">
                            <li className="font-semibold">
                              {formatINRCurrency(
                                loaneeDetails?.full_info?.principle_due,
                              )}
                            </li>
                            <li className="font-semibold">
                              {formatINRCurrency(
                                loaneeDetails?.full_info?.interest_due_amount,
                              )}
                            </li>

                            {loaneeDetails?.full_info?.categoryname ===
                              "OBC" && (
                              <>
                                <li className="font-semibold">
                                  {formatINRCurrency(
                                    +loaneeDetails?.penal_interest,
                                  )}
                                </li>
                                <li className="font-semibold">
                                  {formatINRCurrency(
                                    +loaneeDetails?.interest_on_interest,
                                  )}
                                </li>
                              </>
                            )}
                          </ul>

                          <p className="font-semibold pt-2">
                            Total:{" "}
                            {formatINRCurrency(
                              loaneeDetails?.full_info?.principle_due +
                                loaneeDetails?.full_info?.interest_due_amount ||
                                0,
                            )}
                          </p>
                        </div>
                      </div>

                      <p className="pt-3 ml-6 font-semibold">
                        (Rupees{" "}
                        <span className="font-bold">
                          {" "}
                          {number_in_words(
                            loaneeDetails?.full_info?.principle_due +
                              loaneeDetails?.full_info?.interest_due_amount,
                          ) || 0}
                        </span>{" "}
                        only)
                      </p>

                      {/* Final Paragraph */}
                      <p className="mt-6 leading-relaxed">
                        You are advised to settle the overdues indicated in the
                        above schedule within 15 days from date of receipt of
                        this notice... SPDR Act 1988/Lok Adalat.
                        <br />
                        Soliciting your kind co-operation.
                      </p>

                      {/* Signature Section */}
                      <div className="flex justify-between flex-wrap pt-10 gap-y-6">
                        <div>
                          <p>Name &amp; Signature of the recipient:</p>
                          <p className="font-semibold mt-12 break-words">
                            {loaneeDetails?.full_info?.applicantname}
                          </p>
                          <p className="font-semibold uppercase break-words">
                            {loaneeDetails?.full_info?.permanentaddress}
                          </p>

                          {loaneeDetails?.full_info?.guarantor && (
                            <>
                              <p className="pt-6">Copy To</p>
                              <p>
                                Guarantor Name:{" "}
                                <span className="font-semibold">
                                  {loaneeDetails?.full_info?.guarantor?.name}
                                </span>
                              </p>
                              <p>
                                Guarantor Address:{" "}
                                <span className="font-semibold">
                                  {loaneeDetails?.full_info?.guarantor?.address}
                                </span>
                              </p>
                            </>
                          )}
                        </div>

                        <div className="text-right">
                          <p>Yours faithfully,</p>
                          <p className="mt-12">Asstt. Manager/Manager/Dy.G.M</p>
                        </div>
                      </div>
                    </section>
                  </div>
                ))}
              </div>

              {/* Modal Footer */}
              <div className="flex justify-between items-center mt-4 gap-3">
                <div className="pt-3 text-slate-700">
                  Total: {sendLoanReminderList.length || 0} Demand Notices
                </div>
                <div className="flex justify-end gap-3">
                  <button
                    className="px-4 mt-6 py-2  h-fit bg-gray-300 rounded hover:bg-gray-400"
                    onClick={() => {
                      setShowBulkDemandNotices(false);
                      setSelectedDate("");
                    }}
                  >
                    Close
                  </button>

                  {!showPrintButton ? (
                    <button
                      onClick={() => {
                        handleGenerateBulkDemandNotice();
                      }}
                      className="px-4 py-2 mt-6 h-fit bg-primary text-white  hover:bg-primary"
                    >
                      Generate Refrence Number
                    </button>
                  ) : (
                    <ReactToPrint
                      trigger={() => (
                        <button className="px-4 py-2 mt-6 h-fit bg-primary text-white  hover:bg-primary">
                          Print Notices
                        </button>
                      )}
                      content={() => printRef.current}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <div style={{ display: "none" }}>
        <div ref={printRef}>
          <PrintBulkDemandNotice sendLoanReminderList={sendLoanReminderList} />
        </div>
      </div>
    </Dashboard>
  );
};

export default DefaulterDetailConfig;
